import { ScrollArea, Stack, Text } from '@mantine/core';
import { useTranslation } from '@refinedev/core';
import type { TariffIngestIssue } from '@billing/validation/tariffIngestion';

const IssueList = ({
  color,
  issues,
}: {
  color: 'red' | 'yellow';
  issues: TariffIngestIssue[];
}) => {
  const { translate } = useTranslation();

  return issues.map((issue, index) => (
    <Text
      size="sm"
      c={color}
      key={`${issue.code}-${issue.sourceLine ?? 'file'}-${index}`}
    >
      {issue.sourceLine
        ? `${translate('tariffs.ingest.line', 'Line')} ${issue.sourceLine}: `
        : ''}
      {issue.sourceCode ? `${issue.sourceCode} - ` : ''}
      {issue.message}
    </Text>
  ));
};

export const TariffIngestIssues = ({
  failures,
  warnings,
}: {
  failures: TariffIngestIssue[];
  warnings: TariffIngestIssue[];
}) => {
  if (!failures.length && !warnings.length) return null;

  return (
    <ScrollArea.Autosize mah={260}>
      <Stack gap="xs">
        <IssueList color="red" issues={failures} />
        <IssueList color="yellow" issues={warnings} />
      </Stack>
    </ScrollArea.Autosize>
  );
};
